import React from 'react'

export default function PayPalPaymentGateway() {
  return (
    <div>PayPalPaymentGateway</div>
  )
}
